import * as React from "react";

import {isIFrame} from "@repo/guide-core-helpers";
import {RequestInfo, useUserAttributes} from "@repo/shared-core";

interface Props {
    children: React.ReactNode;
}

/**
 * GuideAccessGate renders its children if the AIGuide feature is eligible for
 * the current session.
 */
export const GuideAccessGate = ({
    children,
}: Props): React.ReactElement | null => {
    const userAttributes = useUserAttributes();

    // Only enable the experience for users who are logged in, and
    // have opted/enrolled into the AIGuide experimental feature.
    if (!userAttributes?.isAIGuideEnabled) {
        return null;
    }

    // If the user does not have permission to access companion mode
    // then disable the experience.
    if (!userAttributes?.hasAccessToAIGuideCompanionMode) {
        return null;
    }

    // We don't want to render the Guide experience when loaded in a frame.
    // unless in Cypress which loads the whole page in an iFrame
    if (!RequestInfo.isE2E && isIFrame()) {
        return null;
    }

    return <>{children}</>;
};
